import clsx from 'clsx';
import Placeholder from 'epn-ui/umd/dist/components/Placeholder';
import { TableProps } from 'epn-ui/umd/dist/components/Table';

export interface IBaseTableMobileItemProps {
    columns: TableProps['columns'];
    data: TableProps['data'][0];
    className?: string;
    isLoading?: boolean;
}

const BaseTableMobileItem: React.FC<IBaseTableMobileItemProps> = ({
    data,
    columns,
    className,
    isLoading = false,
}) => {
    const items = columns.map(col => {
        return {
            key: col.dataKey,
            title: col.title,
            value: data[col.dataKey],
        };
    });

    return (
        <div className={clsx(className, 'py-4 px-3 rounded-2')}>
            {items.map((item, index) => (
                <div className="flex mt-4 text-p1 first:mt-0" key={index}>
                    <div className="flex-1 text-blueGray-600">{item.title}</div>
                    <div
                        {...(item.key === 'name' &&
                            typeof item.value === 'string' && { title: item.value })}
                        className="flex-1 ml-8 text-left truncate text-blueGray-800"
                    >
                        {isLoading ? <Placeholder /> : item.value}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BaseTableMobileItem;
